export default "__VITE_ASSET__CzSgK$y$__"